import { atom } from 'jotai';

import { MiniLigasTO } from '@/types/minileagues';

export type InitialDataMiniligues = {
  id: number;
  idsPlayings: number[];
  showModalInfo?: boolean;
  cantPartMaxXML?: number;
  comenzaronMl?: boolean;
  miniligue: any;
  mlPlaying: any[];
  mlPending: any[];
  idsPendings: number[];
  refreshAfterInvitation?: boolean;
  showModalError?: {
    visible: boolean;
    id: number;
  } | null;
};

export const initialDataMiniligues: InitialDataMiniligues = {
  id: 0,
  showModalInfo: false,
  comenzaronMl: false,
  refreshAfterInvitation: false,
  miniligue: null,
  mlPlaying: [],
  mlPending: [],
  idsPlayings: [],
  idsPendings: [],
  showModalError: null,
  cantPartMaxXML: 0,
};

export const minileagueAtom = atom<InitialDataMiniligues>(
  initialDataMiniligues
);

export type InitialDataMinileague = {
  estado: boolean;
  mensaje: string;
  miniLiga: MiniLigasTO;
};

export const initialDataMinileague: InitialDataMinileague = {
  estado: false,
  mensaje: '',
  miniLiga: { id: 0, length: 0 },
};

export const minileagueDataAtom = atom<InitialDataMinileague>(
  initialDataMinileague
);
